// import { Button } from '@components/common/form';
// import { Container } from 'react-bootstrap';
import React from 'react';
import Developers from '@components/screens/Developers';

// const { TextInput } = require('@components/common/form');
import { WebsiteLayout } from '@components/common/layout';

/**
 * header banner, spanning the width of the page. about
 */
const formInputStyleOverrides = { marginBottom: 15 };

function DevelopersPage({ logout, user }) {
  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <Developers />
    </WebsiteLayout>
  );
}

export default DevelopersPage;
